import { Injectable } from '@angular/core';

declare const Office: { context?: { mailbox?: unknown } } | undefined;

@Injectable({ providedIn: 'root' })
export class OutlookHostContextService {
  hasMailbox(): boolean {
    return typeof Office !== 'undefined' && !!Office?.context?.mailbox;
  }
}
